import React, {createRef, forwardRef, useRef} from 'react';
import PropTypes from 'prop-types';
import parse from "html-react-parser";
import {forEach} from "lodash";

import useDidMountEffect from "../../utils/useDidMountEffect";

const TecRmiSvgHtml = forwardRef((props, forwardedRef) => {
  const listRef = forwardedRef || createRef()

  useDidMountEffect(() => {
    if(props.onDidMount){
      props.onDidMount()
    }
  })

  React.useEffect(() => {
    listRef.current.addEventListener("click", props.handleClick);
  }, [])

  const getHtml = () => {
    let html = props.html

    forEach(props.renameFunctions, (renameTo, renameFrom) => {
      html = html.replaceAll(renameFrom, renameTo)
    })

    return html
  }

  return <React.Fragment>
    <div
      ref={listRef}
      className={`tec-rmi-svg ${props.className}`}
      dangerouslySetInnerHTML={{__html: getHtml()}}
    />
    {parse(props.html, {
      transform: (node, index) => {
        if (node.type === 'script') {
          let externalScript = node?.props?.src ? true : false;

          const script = document.createElement('script');
          if (externalScript) {
            script.src = node?.props?.src;
          } else {
            let jsHtml = node.props.dangerouslySetInnerHTML.__html
            props.excludeJsFunctions.forEach(fnName => {
              jsHtml = jsHtml
                .split(`function `)
                .filter(functionBody => {
                  return functionBody.indexOf(fnName) !== 0
                })
                .join('function ')
            })
            script.innerHTML = jsHtml
          }

          document.head.append(script);
        }
      },
    })}
  </React.Fragment>;
});

TecRmiSvgHtml.defaultProps = {
  excludeJsFunctions: [],
  renameFunctions: {},
  className: '',
};

TecRmiSvgHtml.propTypes = {
  className: PropTypes.string,
  handleClick: PropTypes.func,
  html: PropTypes.any.isRequired,
  excludeJsFunctions: PropTypes.array,
  renameFunctions: PropTypes.object,
  onDidMount: PropTypes.func,
};

export default TecRmiSvgHtml;